import html2canvas from 'html2canvas'

// html2canvas при ненулевом letter-spacing (глобально -0.8px в index.css) рисует текст
// по буквам, и в Safari буквы наезжают друг на друга. Сбрасываем его только в клоне,
// который снимается, и ждём шрифты, чтобы ширины букв были уже настоящие.
export const capturePng = async (el: HTMLElement, scale = 2) => {
    await document.fonts?.ready
    return html2canvas(el, {
        backgroundColor: '#fff',
        scale,
        onclone: (doc) => {
            const style = doc.createElement('style')
            style.textContent = '* { letter-spacing: 0 !important; }'
            doc.head.appendChild(style)
        },
    })
}

// Через blob, а не dataURL: Safari на dataURL открывает вкладку data: вместо скачивания
export const downloadCanvas = async (canvas: HTMLCanvasElement, fileName: string) => {
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/png'))
    if (!blob) throw new Error('empty canvas')
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.download = fileName
    link.href = url
    link.click()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
}
